module.exports = require("hash-sum");


//////////////////
// WEBPACK FOOTER
// external "hash-sum"
// module id = 37
// module chunks = 0